import React from 'react';
import './NewsItemShare.scss';
import { FaWhatsapp, FaViber, FaOdnoklassniki } from 'react-icons/fa6';
import { RiTelegramLine } from 'react-icons/ri';
import { IoLogoVk } from 'react-icons/io';
import { useLocation } from 'react-router-dom';

/*
  Ряд кнопок «поделиться» под заголовком. Раньше это был столбик слева от
  картинки, где иконки красились в --color-inverse и в светлой теме были
  белым по белому.
*/
const NewsItemShare = ({ title = '' }) => {
  const location = useLocation();
  const newsUrl = window.location.origin + location.pathname;
  const text = encodeURIComponent(title);
  const url = encodeURIComponent(newsUrl);

  const links = [
    { name: 'WhatsApp', href: `https://api.whatsapp.com/send?text=${text}%20${url}`, Icon: FaWhatsapp },
    { name: 'Viber', href: `viber://forward?text=${text}%20${url}`, Icon: FaViber },
    { name: 'Telegram', href: `https://t.me/share/url?url=${url}&text=${text}`, Icon: RiTelegramLine },
    { name: 'VK', href: `https://vk.com/share.php?url=${url}&title=${text}`, Icon: IoLogoVk },
    { name: 'Одноклассники', href: `https://connect.ok.ru/offer?url=${url}&title=${text}`, Icon: FaOdnoklassniki },
  ];

  return (
    <div className="newsItemShare_block">
      {links.map(({ name, href, Icon }) => (
        <a
          key={name}
          className="newsItemShare_btn"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={'Поделиться в ' + name}
        >
          <Icon aria-hidden="true" />
        </a>
      ))}
    </div>
  );
};

export default NewsItemShare;
